<router-outlet>
</router-outlet>
<p-confirmDialog appendTo='body' [rejectVisible]="true" [baseZIndex]="100000000" width="300"></p-confirmDialog>
